
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("awGHE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $53d5Q = parcelRequire("53d5Q");

function $7eb4f108e5ed40d6$var$createTerminalErrorPayload(errorData, context) {
    const config = (0, $53d5Q.getConfig)();
    if (!config) return null;
    return {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: {
                'event:hostname': window.location?.hostname || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:source': {
                    name: 'react-ufo/web',
                    version: '1.0.1'
                },
                'event:region': config.region || 'unknown',
                'experience:key': 'custom.terminal-error',
                terminalError: errorData,
                ...context
            }
        }
    };
}
var $7eb4f108e5ed40d6$export$2e2bcd8739ae039 = $7eb4f108e5ed40d6$var$createTerminalErrorPayload;
module.exports["default"] = $7eb4f108e5ed40d6$export$2e2bcd8739ae039;

});


//# sourceMappingURL=create-terminal-error-payload.3b58c414.js.map
